export enum UserRole {
    Administration = "Administration",
    ClinicalService = "Clinical Service",
    Other = "Other (Free Text)",
    PharmacyAdmin = "PharmacyAdmin",
    PharmacyAssistantDirector = "Pharmacy Assistant Director",
    PharmacyClinicalManager = "Pharmacy Clinical Manager",
    PharmacyDirector = "Pharmacy Director",
    PharmacyManager = "Pharmacy Manager",
    PharmacyOperationsManager = "Pharmacy Operations Manager",
    PharmacyOwnerLeadership = "Pharmacy Owner/Leadership",
    PharmacyOwnerManager = "Pharmacy Owner/Manager",
    ReelMember = "ReelMember",
    SuperUser = "Super User"
  }
  